import { FETCH_CURRENCY_LIST, FETCH_CURRENCY_RATES } from 'actionTypes';
import { successAction } from 'utils/redux';
import createReducer from './createReducer';

const initialState = {
  currenciesItems: {
    all: [],
    money: [],
    crypto: [],
  },
  currencyRates: null,
};

const convertor = createReducer(initialState, {
  [successAction(FETCH_CURRENCY_LIST)]: (state, action) => ({
    ...state,
    currenciesItems: {
      ...state.currenciesItems,
      [action.params.type]: [
        ...state.currenciesItems[action.params.type],
        ...action.payload.list,
      ],
    },
  }),

  [successAction(FETCH_CURRENCY_RATES)]: (state, action) => ({
    ...state,
    currencyRates: Object.values(action.payload.data),
  }),
});

export default convertor;
